import { Outlet } from 'react-router-dom';
import { BaseBreadcrumb } from '@components';
import { useBreadcrumbItems } from '@utils/general.tsx';

import { ContentLayoutWrapper } from './styled.ts';

export const MainContent = () => {
    const items = useBreadcrumbItems();
    return (
        <ContentLayoutWrapper>
            <BaseBreadcrumb items={items} separator={''} />
            <Outlet />
        </ContentLayoutWrapper>
    );
};
